export const getLayerStrokeCap = (layer: any) => {
  if (!layer.strokeCap) {
    return 'NONE';
  }

  return layer.strokeCap;
};
